$(document).on('click', '[id^=drawer-filter-]', function(){
  if( $(this).is(':checked') ){
    var filterOption = $(this)[0].value;
    var filterName = $(this)[0].name.split(".").pop();
    console.log($(this));
    gtag('event', 'select_content', {
      content_type: 'filter_' + filterName,
      item_id: filterOption
    });
  }
});

$(document).on('click', '.Header__MainNav a', function(){
  var menuLabel = $(this).attr('href').split("/").pop();
  console.log(menuLabel);
  gtag('event', 'select_menu', {
    'event_category': 'menu_pc',
    'event_label': menuLabel
  });
});

$(document).on('click', '.SidebarMenu__Nav a', function(){
  var menuLabel = $(this).attr('href').split("/").pop();
  console.log(menuLabel);
  gtag('event', 'select_menu', {
    'event_category': 'menu_mb',
    'event_label': menuLabel
  });
});

